import React from "react";
import FaqComponent from "../../common/FaqComponent";

// const faqData = {
//   title: "Frequently Asked Questions",
//   description:
//     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the",
//   viewAllLink: "/faq",
//   faqItems: [
//     {
//       question:
//         "Lorem ipsum dolor sit amet consectetur. Velit a eu morbi aliquet dui elit massa cursus.",
//       answer:
//         "Lorem ipsum dolor sit amet consectetur. Cursus in facilisis risus pulvinar. Facilisi ut vulputate pellentesque mauris potential dui vel. Donec gravida sit amet.",
//     },
//     {
//       question:
//         "Lorem ipsum dolor sit amet consectetur. Et iaculis malesuada suspendisse ornare sed.",
//       answer:
//         "Lorem ipsum dolor sit amet consectetur. Cursus in facilisis risus pulvinar. Facilisi ut vulputate pellentesque mauris potential dui vel. Donec gravida sit amet.",
//     },
//     {
//       question:
//         "Lorem ipsum dolor sit amet consectetur. Viverra est non faucibus ut ultricies amet.",
//       answer:
//         "Lorem ipsum dolor sit amet consectetur. Cursus in facilisis risus pulvinar. Facilisi ut vulputate pellentesque mauris potential dui vel. Donec gravida sit amet.",
//     },
//     {
//       question:
//         "Lorem ipsum dolor sit amet consectetur. Viverra leo semper tempor scelerisque diam auctor sed nec justo.",
//       answer:
//         "Lorem ipsum dolor sit amet consectetur. Cursus in facilisis risus pulvinar. Facilisi ut vulputate pellentesque mauris potential dui vel. Donec gravida sit amet.",
//     },
//     {
//       question:
//         "Lorem ipsum dolor sit amet consectetur. Nulla sed posuere scelerisque cum.",
//       answer:
//         "Lorem ipsum dolor sit amet consectetur. Cursus in facilisis risus pulvinar. Facilisi ut vulputate pellentesque mauris potential dui vel. Donec gravida sit amet.",
//     },
//     {
//       question:
//         "Lorem ipsum dolor sit amet consectetur. Natoque iaculis praesent tristique sit non porttitor et luctus porttitor.",
//       answer:
//         "Lorem ipsum dolor sit amet consectetur. Cursus in facilisis risus pulvinar. Facilisi ut vulputate pellentesque mauris potential dui vel. Donec gravida sit amet.",
//     },
//   ],
// };

export const Faq = ({ data }) => {
  // Access products_section from the data object
  const { faqs } = data || {};

  // Safely destructure products array with default empty array
  const { description = "", questions = [] } = faqs || {};

  return <FaqComponent description={description} questions={questions} />;
};

export default Faq;
